module.exports = __webpack_public_path__ + "img/3.d8b2ea1f.png";